<template>
  <div class="form-content">
    <v-form ref="form" v-model="valid" lazy-validation class="bg-white dark-bg-custom">
      <div class="flex justify-between items-center p-4">
        <h3 class="form-title">Add Amc List</h3>
        <v-icon @click="cancel">mdi-close</v-icon>
      </div>
      <v-divider></v-divider>
      <div class="p-4">
        <v-row dense>
          <v-col cols="12" md="6">
            <v-select
              v-model="amcPlan"
              :items="amcPlans"
              item-text="planName"
              label="Amc Plan Name"
              item-value="_id"
              outlined
              dense
              hide-details
              @change="handleChange"
              :rules="[(v) => !!v || `Plan name is required`]"
            ></v-select>
          </v-col>
          <v-col cols="12" md="6">
            <v-autocomplete
              v-model="productSell"
              :items="leads"
              label="Customer/Product Sr.No"
              item-text="label"
              item-value="_id"
              :search-input.sync="searchLead"
              @update:search-input="debounceLead"
              dense
              outlined
              hide-details
              :rules="[(v) => !!v || `Customer/Product Sr.No is required`]"
            ></v-autocomplete>
          </v-col>

          <v-col v-if="amcPlan" cols="12" md="6">
            <v-text-field
              v-model="coverage"
              label="Coverage"
              dense
              outlined
              hide-details
              readonly
            ></v-text-field>
          </v-col>

          <v-col v-if="amcPlan" cols="12" md="6">
            <v-text-field
              v-model="planDescription"
              label="Plan Description"
              dense
              outlined
              readonly
              hide-details
            ></v-text-field>
          </v-col>

          <v-col cols="12" md="6">
            <v-text-field
              type="datetime-local"
              v-model="amcEffectivefrom"
              label="Effective Date"
              outlined
              dense
              hide-details
              :rules="[(v) => !!v || `Effective date is required`]"
            ></v-text-field>
          </v-col>
        </v-row>
      </div>

      <div class="border-t border-gray-300 p-4 flex justify-end items-center">
        <v-btn text class="normal-case" @click="cancel">Cancel</v-btn>
        <v-btn
          class="white--text ml-2 normal-case"
          :color="$vuetify.theme.currentTheme.primary"
          @click="addAmc"
        >
          <v-icon left>mdi-content-save</v-icon>Save</v-btn
        >
      </div>
    </v-form>
  </div>
</template>

<script>
import { debounce } from '@/utils/common'
export default {
  data() {
    return {
      amcPlan: null,
      location: '',
      amcEffectivefrom: null,
      productSell: null,
      searchLead: null,
      amcPlans: [],
      leads: [],
      valid: true
    }
  },
  async mounted() {
    await this.getAmcPlans()
    // await this.getLeads();
  },
  methods: {
    addAmc() {
      try {
        const isValid = this.$refs.form.validate()
        if (!isValid) return

        const payload = {
          productSell: this.productSell,
          amcPlan: this.amcPlan,
          amcEffectivefrom: this.amcEffectivefrom
        }
        this.$axios.post('/ecom/amc/sell', payload)
        this.$toast.success('AMC added successfully')
        this.$emit('saved') // Emit saved event
        this.cancel()
      } catch (error) {
        this.$toast.error(error)
        console.log(error)
      }
    },
    cancel() {
      this.$emit('cancel')
    },
    async getAmcPlans() {
      try {
        const response = await this.$axios.get('/ecom/amcplans')
        this.amcPlans = response.data?.plans
      } catch (error) {
        console.log(error)
      }
    },
    debounceLead: debounce(async function (text) {
      if (!text) {
        return
      }
      const selectedItem = this.leads.find((lead) => lead.label === text)
      if (selectedItem) {
        this.productSell = selectedItem
      } else {
        await this.getLeads()
      }
    }, 800),

    async getLeads() {
      try {
        const params = {}

        if (this.searchLead) {
          params.search = this.searchLead
          params.useCase = 'inventory'
        }
        const response = await this.$axios.get('/lead/org', {
          params
        })
        this.leads = response.data?.leads.map((el) => {
          return {
            ...el,
            label: `${el.leadTitle || ''} - ${el.company?.name || ''}`
          }
        })
      } catch (error) {
        console.log(error)
      }
    },
    handleChange() {
      const selectedPlan = this.amcPlans.find((el) => el._id === this.amcPlan)
      this.coverage = selectedPlan?.coverage
      this.planDescription = selectedPlan?.planDescription
    }
  }
}
</script>
<style scoped>
/* .form-content {

} */
.form-title {
  font-size: 1.25rem;
  padding: 0px !important;
  font-weight: 600;
  color: #21427d;
  margin: 0;
}
</style>
